<template>
  <span v-if="inventory">
    <b-tooltip :target="`group-item-span-${inventory.uuid}`" :title="$t('Group Item')"/>
    <b-tooltip :target="`grouped-item-span-${inventory.uuid}`" :title="$t('Grouped Item')"/>
    <span v-if="inventory.is_grouped_item" class="badge badge-primary ml-2"
          :id="`group-item-span-${inventory.uuid}`">
      <font-awesome-icon icon="boxes" class="icon"/>
      {{ inventory.source_inventories_count }}
    </span>
    <span
        :id="`grouped-item-span-${inventory.uuid}`"
        v-else-if="!inventory.is_grouped_item && inventory.grouped_inventories_count && inventory.grouped_inventories_count > 0"
        class="badge badge-primary ml-2">
      <font-awesome-icon icon="box" class="icon"/>
      {{ inventory.grouped_inventories_count }}
    </span>
  </span>
</template>

<script>
  export default {
    name: "GroupedItemIndicator",
    props: {
      inventory: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style scoped>

</style>